export default {
    _default: (field) => `قيمة الحقل غير صحيحة.`,
    _invalid_format: (field, {format}) => `The field must be in the format ${format}.`,
    _atLeastOneRule: (field) => ` TODO `,
    equals: (field) => `قيمة الحقل TODO .`,
    after: (field, {target}) => `يجب ان يكون بعد ${target}.`,
    alphadash: (field) => `قد يحتوي على حروف او الرموز - و _.`,
    alphanumeric: (field) => `قد يحتوي فقط على حروف وارقام.`,
    alphaspaces: (field) => `قد يحتوي فقط على حروف ومسافات.`,
    alpha: (field) => `يجب ان يحتوي على حروف فقط.`,
    before: (field, {target}) => `يجب ان يكون قبل ${target}.`,
    between: (field, {from, to}) => `قيمة يجب ان تكون ما بين ${from} و ${to}.`,
    dateBetween: (field, {min, max}) => `يجب ان يكون ما بين ${min} و ${max}.`,
    date: (field, {format}) => `يجب ان يكون على هيئة ${format}.`,
    time: (field) => `يجب ان يكون على هيئة HH:mm:ss.`,
    datetime: (field, {format}) => `يجب ان يكون على هيئة ${format}.`,
    decimal: (field, {decimals = '*'} = {}) => `يجب ان يكون قيمة رقمية وقد يحتوي على ${decimals === '*' ? '' : decimals} ارقام عشرية.`,
    digits: (field, {length}) => `يجب ان تحتوي فقط على ارقام والا يزيد عددها عن ${length} رقم.`,
    email: (field) => `يجب ان يكون بريدا اليكتروني صحيح.`,
    in: (field) => `الحقل يجب ان يكون قيمة صحيحة.`,
    integer: (field) => `الحقل يجب ان يكون عدداً صحيحاً`,
    ip: (field) => `يجب ان يكون ip صحيح.`,
    maxlength: (field, {length}) => `الحقل يجب ان يحتوي على ${length} حروف على الأكثر.`,
    max: (field, {min}) => `قيمة الحقل يجب ان تكون اصغر من ${min} او تساويها.`,
    minlength: (field, {length}) => `الحقل يجب ان يحتوي على ${length} حروف على الأقل.`,
    min: (field, {min}) => `قيمة الحقل يجب ان تكون اكبر من ${min} او تساويها.`,
    numeric: (field) => `يمكن ان يحتوي فقط على ارقام.`,
    match: (field) => `الحقل غير صحيح.`,
    required: (field) => `مطلوب.`,
    url: (field) => `الحقل يجب ان يكون رابطاً صحيحاً.`
};
